import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { captureAuthFragments, UiProvider } from '@despachador/ui';
import '@despachador/ui/styles.css';
import './admin.css';
import { App } from './App';
import { applyTheme, storedTheme } from './lib/theme';

// the chosen theme before the first paint: no flash of the other one
applyTheme(storedTheme());

// an invitation link and Google's return carry secrets in the fragment: take them out of the address bar before anything else runs
captureAuthFragments();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <UiProvider>
      <App />
    </UiProvider>
  </StrictMode>,
);
